import React from "react";

// Simulated data for the bio

const VideosTab = ({ highlights }) => {
  return (
    <div className="videos-tab">
      <div className="videos-box">
        {highlights.tiktok.map((video, index) => (
          <iframe
            src={video + "?&music_info=1&description=0&loop=1&rel=0"}
            width="325"
            height="605"
            style={{ maxWidth: "100%", minWidth: "325px" }}
            frameBorder="0"
            allow="fullscreen"
            title="Highlight Video"
            key={index}
          ></iframe>
        ))}
        {highlights.youtube.map((video, index) => (
          <iframe
            src={video + "?loop=1&rel=0"}
            width="325"
            height="605"
            style={{ maxWidth: "100%", minWidth: "325px" }}
            frameBorder="0"
            allow="fullscreen"
            title="Highlight Video"
            key={index}
          ></iframe>
        ))}
      </div>
    </div>
  );
};

export default VideosTab;
